import React from 'react'
import Footer from './Footer'

import Slide0 from "./slide0"
import Slide1 from "./slide1"
import Slide2 from "./slide2"
import Slide3 from "./slide3"
import Slide4 from "./slide4"
import Slide5 from "./slide5"
import Slide6 from "./slide6"
import Content from "./content"

import pdf from "../img/4518956_adobe_file_pdf_type_icon.png"
import fb from "../img/771366_facebook_logo_media_network_social_icon.png"
import insta from "../img/5296765_camera_instagram_instagram logo_icon.png"
import twitter from "../img/4102580_applications_media_social_twitter_icon.png"

const Home = () => {
    return (
        <div>
            <Slide1/>
            <Slide2/>
            <Slide3/>
            <Slide4/>
            <Slide0/>
            <Slide5/>
            <Slide6/>
            <Content/>
            <a className="pdf" title="Den Text als Pdf herunterladen" target="_blank" href="http://download1646.mediafire.com/rbl7xffppxrg/m6ojmn2y2ba9tq4/Aufruf+mit+Unterschriften2.pdf" download><img src={pdf}></img></a>
            <a className="fb" title="zu unsere Facebook (Alte grüne Zukunft)" target="_blank" href="https://www.facebook.com/jochen.lehnert.7"><img src={fb}></img></a>
            <a className="insta" title="zu unsere Instagram (Alte grüne Zukunft)" target="_blank" href="https://instagram.com/altegruenezukunft?utm_medium=copy_link"><img src={insta}></img></a>
            <a className="twitter" title="zu unsere Twitter (Alte grüne Zukunft)" target="_blank" href="https://twitter.com/AlteGruene"><img src={twitter}></img></a>
            <Footer />
        </div>
    )
}

export default Home
